/** Pack helpers for LinkedIn job share (crawler OG URL + prompt-on-publish). */

export const LINKEDIN_SHARE_OFFSITE_DESCRIPTION =
  'You will open LinkedIn to share this job. Copy the message below and paste it into your post if you like. LinkedIn’s share link cannot include this caption.'

export const LINKEDIN_SHARE_OFFSITE_PAGE_HINT =
  'If you administer a company Page, you can switch the author to that Page inside LinkedIn before you post.'

export const LINKEDIN_SHARE_OFFSITE_CAPTION_HINT =
  'LinkedIn opens with the job link only — copy this message to paste into your post.'

export const LINKEDIN_SHARE_MEMBER_DESCRIPTION =
  'Post this job to your LinkedIn profile using your connected account.'

export const LINKEDIN_SHARE_MEMBER_CAPTION_HINT =
  'This text will be posted to your LinkedIn profile.'

export function linkedInJobOgSharePath(publicSlug: string | null | undefined): string {
  const slug = (publicSlug ?? '').trim()
  if (!slug) return ''
  return `/api/public/opportunities/${encodeURIComponent(slug)}/share`
}

export function linkedInJobOgShareUrl(
  publicSlug: string | null | undefined,
  apiOrigin: string,
): string {
  const path = linkedInJobOgSharePath(publicSlug)
  if (!path) return ''
  const origin = (
    apiOrigin.trim() ||
    (typeof window !== 'undefined' ? window.location.origin : '')
  ).replace(/\/$/, '')
  if (!origin) return ''
  return `${origin}${path}`
}

export function shouldPromptLinkedInShareOnPublish(featureEnabled: boolean): boolean {
  return featureEnabled
}

/** OAuth return (`connected`) or post-publish prompt (`prompt`) should reopen the share dialog. */
export function shouldOpenLinkedInShareFromQuery(linkedinShareParam: string | null): boolean {
  return linkedinShareParam === 'connected' || linkedinShareParam === 'prompt'
}
